import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Besttaxiserviceinmumbai() {



  const cardData =
  {
    keyword: 'Best Taxi Service in Mumbai ',
    heading: 'Shambhu Cabs: Best Taxi Service in Mumbai',
    headingDescription: 'Shambhu Cabs offers the best Taxi Service in Mumbai, providing safe, comfortable, and reliable transportation for families, corporate travelers, business professionals, and tourists throughout the city. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures smooth travel with well-maintained vehicles and spacious seating. With flexible hourly, daily, and airport transfer options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes city travel convenient, stress-free, and punctual. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted taxi services in Mumbai for travelers seeking comfort, safety, and a dependable urban travel experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Top Taxi Service Mumbai",
    "description": "Top Taxi Service Mumbai offers premium, reliable, and comfortable taxi services across the city. Ideal for both business and personal travel, this service emphasizes punctuality, well-maintained vehicles, and professional drivers familiar with all major routes in Mumbai."
  },
  {
    "name": "Reliable Taxi Mumbai",
    "description": "Reliable Taxi Mumbai ensures safe and timely transport with experienced drivers who know the city inside out. With a focus on dependability and consistent service, this taxi option is perfect for daily commuters, airport transfers, and intercity travel."
  },
  {
    "name": "Affordable Taxi Mumbai",
    "description": "Affordable Taxi Mumbai provides budget-friendly transportation without compromising on safety or comfort. Transparent pricing, easy booking, and reliable service make it ideal for students, families, and local travelers looking for economical city rides."
  },
  {
    "name": "Safe Taxi Service Mumbai",
    "description": "Safe Taxi Service Mumbai prioritizes passenger safety with GPS-enabled cabs, trained drivers, and strict adherence to traffic regulations. Perfect for families, solo travelers, and elderly passengers seeking secure and worry-free travel across Mumbai."
  },
  {
    "name": "Premium Taxis in Mumbai",
    "description": "Premium Taxis in Mumbai offer luxury vehicles, professional chauffeurs, and top-notch service for VIP clients, business travelers, and special occasions. These taxis ensure a comfortable, stylish, and stress-free travel experience."
  },
  {
    "name": "24×7 Taxi Mumbai",
    "description": "24×7 Taxi Mumbai guarantees round-the-clock availability for pickups and drop-offs. Travelers can rely on prompt service anytime, day or night, with experienced drivers and well-maintained vehicles ready for immediate dispatch."
  },
  {
    "name": "Local Taxi Mumbai",
    "description": "Local Taxi Mumbai specializes in intra-city travel, providing quick and convenient rides to offices, schools, shopping centers, and other local destinations. Drivers are familiar with city traffic patterns to ensure efficient and timely journeys."
  },
  {
    "name": "Long Distance Taxi Mumbai",
    "description": "Long Distance Taxi Mumbai offers comfortable and reliable transportation for intercity travel. Ideal for business trips, family vacations, or weekend getaways, these taxis provide well-maintained vehicles, professional drivers, and flexible booking options."
  },
  {
    "name": "Airport Taxi Mumbai",
    "description": "Airport Taxi Mumbai ensures seamless airport transfers with punctual pickups and drop-offs. Available for both domestic and international airports, this service prioritizes comfort, timeliness, and hassle-free travel for passengers catching flights."
  },
  {
    "name": "Mumbai City Taxi Service",
    "description": "Mumbai City Taxi Service provides comprehensive taxi coverage within the city, catering to daily commuters, corporate clients, and tourists. Vehicles are regularly sanitized, and drivers follow all safety protocols to deliver a reliable and comfortable ride."
  },
  {
    "name": "Fast Taxi Mumbai",
    "description": "Fast Taxi Mumbai specializes in quick, efficient, and on-time rides across the city. Drivers take optimized routes to avoid traffic delays, ensuring passengers reach their destinations promptly and safely."
  },
  {
    "name": "Verified Taxi Drivers Mumbai",
    "description": "Verified Taxi Drivers Mumbai provides rides exclusively with vetted and background-checked drivers. This service guarantees safety, professionalism, and peace of mind for passengers traveling anywhere in Mumbai."
  },
  {
    "name": "Best Rated Taxi Mumbai",
    "description": "Best Rated Taxi Mumbai is known for its exceptional customer reviews and high-quality service. Committed to punctuality, comfort, and safety, these taxis consistently deliver a superior travel experience for all types of journeys."
  },
  {
    "name": "AC Taxi Mumbai",
    "description": "AC Taxi Mumbai provides air-conditioned rides for a comfortable journey across the city. Perfect for summer travel, corporate clients, and long trips, these taxis are regularly maintained to ensure a pleasant and relaxing ride."
  },
  {
    "name": "Online Taxi Booking Mumbai",
    "description": "Online Taxi Booking Mumbai allows passengers to reserve taxis instantly through digital platforms. With secure payments, multiple vehicle options, and real-time tracking, this service offers a convenient and hassle-free booking experience."
  },
  {
    "name": "Mumbai Taxi Near Me",
    "description": "Mumbai Taxi Near Me helps users find nearby cabs quickly for immediate pickups. This service is designed for convenience, offering fast response times, safe rides, and professional drivers ready to travel anywhere in the city."
  },
  {
    "name": "Mumbai Trusted Taxi Service",
    "description": "Mumbai Trusted Taxi Service provides reliable, safe, and professional transportation across the city. Known for consistent quality, verified drivers, and well-maintained vehicles, it is an ideal choice for both local travel and longer trips from Mumbai."
  }
],

"tableData": [
  ["Top Taxi Service Mumbai", "Reliable Taxi Mumbai"],
  ["Affordable Taxi Mumbai", "Safe Taxi Service Mumbai"],
  ["Premium Taxis in Mumbai", "24×7 Taxi Mumbai"],
  ["Local Taxi Mumbai", "Long Distance Taxi Mumbai"],
  ["Airport Taxi Mumbai", "Mumbai City Taxi Service"],
  ["Fast Taxi Mumbai", "Verified Taxi Drivers Mumbai"],
  ["Best Rated Taxi Mumbai", "AC Taxi Mumbai"],
  ["Online Taxi Booking Mumbai", "Mumbai Taxi Near Me"],
  ["Mumbai Trusted Taxi Service", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Best Taxi Service in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers the best taxi service in Mumbai, ideal for airport transfers, city travel, and comfortable rides across the city."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced taxis for a safe and enjoyable experience in Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Roads",
    "WhyChoosedescription": "Our professional drivers have excellent knowledge of Mumbai routes, ensuring timely, smooth, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide upfront and clear pricing—fuel, tolls, and driver allowances included—making your taxi experience in Mumbai stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for City Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans designed for your Mumbai city travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All taxis are thoroughly cleaned and sanitized before each journey, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your travel in Mumbai smooth, comfortable, and worry-free."
  }
]
































  }

const faqData = [
  {
    question: 'Is Shambhu Cabs considered the best taxi service in Mumbai?',
    answer: 'Yes, Shambhu Cabs is recognized as one of the best taxi services in Mumbai, offering reliable, safe, and comfortable rides with professional drivers.',
  },
  {
    question: 'How can I book a taxi with the best taxi service in Mumbai?',
    answer: 'You can book easily through Shambhu Cabs’ website, mobile app, or by contacting our 24x7 customer support team for hassle-free service.',
  },
  {
    question: 'What types of vehicles are available with the best taxi service in Mumbai?',
    answer: 'Shambhu Cabs offers a variety of vehicles including sedans, SUVs, and luxury cars suitable for both individual and group travel in Mumbai.',
  },
  {
    question: 'Are drivers experienced with the best taxi service in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-versed with all routes in Mumbai to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations with the best taxi service in Mumbai?',
    answer: 'Absolutely. You can select any pickup and drop-off points anywhere in Mumbai according to your convenience.',
  },
  {
    question: 'Is the taxi service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs operates round-the-clock, providing taxi services in Mumbai at any time of day or night.',
  },
  {
    question: 'Are safety and hygiene protocols followed by the best taxi service in Mumbai?',
    answer: 'All vehicles are regularly sanitized, and drivers follow strict safety and hygiene protocols to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available with the best taxi service in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the taxi journey in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your taxi journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ankit Sharma',
    feedback: 'Shambhu Cabs truly offers the best taxi service in Mumbai. The drivers are punctual, vehicles are clean, and the service is excellent.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Verma',
    feedback: 'Highly satisfied with Shambhu Cabs! Best taxi service in Mumbai for local travel and airport transfers.',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Taxi Service in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/best-taxi-service-mumbai.jpg",
  "description": "Shambhu Cabs provides the best taxi service in Mumbai with safe, reliable, and affordable rides. Book AC, premium, local, airport, or long-distance taxis. Available 24×7 with verified drivers, online booking, fast pickups, and trusted service across the city.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "350",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/best-taxi-service-in-mumbai"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Best Taxi Service in Mumbai | Safe & Reliable Taxis | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book the best taxi service in Mumbai with Shambhu Cabs. Safe, reliable, and affordable rides including AC, premium, local, airport, and long-distance taxis. Available 24×7 with verified drivers, fast pickups, online booking, and trusted city-wide service."
  />

  <meta
    name="keywords"
    content="Top Taxi Service Mumbai, Reliable Taxi Mumbai, Affordable Taxi Mumbai, Safe Taxi Service Mumbai, Premium Taxis in Mumbai, 24×7 Taxi Mumbai, Local Taxi Mumbai, Long Distance Taxi Mumbai, Airport Taxi Mumbai, Mumbai City Taxi Service, Fast Taxi Mumbai, Verified Taxi Drivers Mumbai, Best Rated Taxi Mumbai, AC Taxi Mumbai, Online Taxi Booking Mumbai, Mumbai Taxi Near Me, Mumbai Trusted Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Besttaxiserviceinmumbai;